import { EnvService } from '../env.service';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../env.service";
export class SearchService {
    constructor(http, envService) {
        this.http = http;
        this.httpOptions = {};
        this.apiURL = '';
        this.apiURL = envService.API_URL;
    }
    getPromotions(bounds) {
        let apiUrl = this.apiURL + 'search/promotions';
        if (bounds) {
            if (bounds.sw) {
                apiUrl += '/@' + bounds.sw.lat + ',' + bounds.sw.lng;
                if (bounds.ne) {
                    apiUrl += '/@' + bounds.ne.lat + ',' + bounds.ne.lng;
                }
                return this.http.get(apiUrl + '?optimized=1');
            }
        }
    }
    getGeoLocation() {
        let apiUrl = this.apiURL + 'geoip/city';
        return this.http.get(apiUrl);
    }
    removeOldNextSessions(promos) {
        return _(promos)
            .map(this.withoutOldSessions)
            .value();
    }
    withoutOldSessions(promo) {
        const now = moment();
        promo.next_sessions = _(promo.next_sessions)
            .filter((session) => {
            return now.isBefore(session.startdate);
        })
            .value();
        return promo;
    }
    doFilter(item) {
        return Array.isArray(item.next_sessions) && item.next_sessions.length > 0;
    }
    isPurchasable(items) {
        return _(items).filter(this.doFilter).value();
    }
    getNextSessionTimestamp(promotion) {
        return _(promotion.next_sessions)
            .map('startdate_timestamp')
            .sortBy()
            .first();
    }
    getPurchasablePromotions(allPromotions) {
        const filteredPromotions = this.removeOldNextSessions(allPromotions.result);
        const purchasblePromotions = this.isPurchasable(filteredPromotions);
        purchasblePromotions.sort((a, b) => {
            return new Date(this.getNextSessionTimestamp(a)).getTime() - new Date(this.getNextSessionTimestamp(b)).getTime();
        });
        return purchasblePromotions;
    }
    applyFilterGroup(data, filterGroup) {
        if (Array.isArray(filterGroup) || filterGroup.length === 0) {
            return data;
        }
        const filterOR = (item) => {
            let result = false;
            _.each(filterGroup, (filter) => {
                result = result || filter.filter(item);
            });
            return result;
        };
        return _(data)
            .filter(filterOR)
            .value();
    }
    // Duration Filters
    // Filter for promotions with only one session
    filterIsDropIn(promo) {
        return promo.session_custom_value === 1;
    }
    // Filters for promotions with more than one session
    filterIsSeries(promo) {
        return promo.session_custom_value > 1;
    }
    // Pricing Filters
    // Filter for promotions with total_amount ~ 0
    filterIsFree(promo) {
        return promo.total_amount === 0 || promo.total_amount === null;
    }
    // Filter for promotions with total_amount < retail_value
    filterIsDiscount(promo) {
        return promo.total_amount < promo.retail_value && promo.total_amount > 0;
    }
    // Filter for promotion with any amount
    filterIsAny(promo) {
        return true;
    }
    filterIsYoga(promo) {
        return promo.parent_category_id === 1;
    }
    filterIsGroupFitness(promo) {
        return promo.parent_category_id === 4;
    }
    filterIsDance(promo) {
        return promo.parent_category_id === 28;
    }
    filterIsClass(promo) {
        return promo.classes.categories.filter(cat => cat.id === 66 || cat.id === 67 || cat.id === 68).length > 0;
    }
    filterIsBootcamp(promo) {
        return promo.classes.categories.filter(cat => cat.id === 24).length > 0;
    }
    filterIsWorkshop(promo) {
        return promo.classes.categories.filter(cat => cat.id === 64 || cat.id === 65).length > 0;
    }
    filterIsTeacherTraining(promo) {
        return promo.classes.categories.filter(cat => cat.id === 69).length > 0;
    }
}
SearchService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SearchService_Factory() { return new SearchService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EnvService)); }, token: SearchService, providedIn: "root" });
